import { apiClient } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const validatePromoCode = async (promoData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/promos/validate", promoData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllPromoCodes = async (
  userId: string | number
): Promise<any> => {
  try {
    const response = await apiClient.get("/promo-codes/all/", {
      params: { user_id: userId },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createPromoCode = async (promoData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/promo-codes/create", promoData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePromoCode = async (
  id: string,
  promoData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/promo-codes/update/${id}`, promoData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deletePromoCode = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/promo-codes/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
